import { render, staticRenderFns } from "./BasePagination.vue?vue&type=template&id=898a4abe"
import script from "./BasePagination.vue?vue&type=script&lang=js"
export * from "./BasePagination.vue?vue&type=script&lang=js"
import style0 from "./BasePagination.vue?vue&type=style&index=0&id=898a4abe&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports